<template>
  <div class="showcase">
    <ucar-title>{{title}}</ucar-title>
    <ucar-img-header type="showcase" :rent="type === 'rent'" @click.native="toggleFilter()"></ucar-img-header>
    <div class="showcase-body">
      <div class="showcase-ctrl">
        <div class="showcase-ctrl-tab">
          <div class="showcase-ctrl-tab-item active" :class="{'expand': showGroupFilter}" v-if="type !== 'rent'" @click="toggleFilter('Group')">{{currentGroup.text}}</div>
          <div class="showcase-ctrl-tab-item sort" :class="{'active': currentSort.val !== 0, 'expand': showSortFilter}" @click="toggleFilter('Sort')">{{currentSort.text}}</div>
          <div class="showcase-ctrl-tab-item" :class="{'active': currentType !== '不限', 'expand': showTypeFilter}" @click="toggleFilter('Type')">{{currentType === '不限' ? '专车类型' : currentType}}</div>
          <div class="showcase-ctrl-tab-item" :class="{'active': currentMonthlyPayment !== '不限', 'expand': showMonthlyPaymentFilter}" v-if="type !== 'rent'" @click="toggleFilter('MonthlyPayment')">
            {{currentPaymentText}}
          </div>
          <div
            class="showcase-ctrl-tab-item"
            :class="{'active': currentRent !== '不限', 'expand': showRentFilter}"
            v-if="type === 'rent'"
            @click="toggleFilter('Rent')"
          >{{currentPaymentText}}</div>
        </div>
        <div class="showcase-ctrl-panel">
          <ul v-if="type !== 'rent' && showGroupFilter">
            <li v-for="item in groupOptions" :key="item.val" :class="{ 'active': currentGroup.val === item.val }" @click="changeFilter('Group', item)">{{item.text}}</li>
          </ul>
          <ul v-if="showSortFilter">
            <li v-for="item in sortOptions" :key="item.val" :class="{ 'active': currentSort.val === item.val }" @click.stop.prevent="changeFilter('Sort', item)">{{item.text}}</li>
          </ul>
          <ul v-if="showTypeFilter">
            <li v-for="item in typeOptions" :key="item + ''" :class="{ 'active': currentType === item }" @click="changeFilter('Type', item)">{{item}}</li>
          </ul>
          <ul v-if="type !== 'rent' && showMonthlyPaymentFilter">
            <li v-for="item in monthlyPaymentOptions" :key="item + ''" :class="{ 'active': currentMonthlyPayment === item }" @click="changeFilter('MonthlyPayment', item)">{{item}}</li>
          </ul>
          <ul v-if="type === 'rent' && showRentFilter">
            <li v-for="item in rentOptions" :key="item + ''" :class="{ 'active': currentRent === item }" @click="changeFilter('Rent', item)">{{item}}</li>
          </ul>
        </div>
      </div>
      <div class="showcase-mask" v-if="showMask" @click="toggleFilter()"></div>
      <ul v-if="finalList.length > 0">
        <li v-for="item in finalList" :key="item.name">
          <img :src="item.imgUrl">
          <div class="showcase-content-item">
            <div class="content-item-header">
              <h2 class="content-item-title">{{item.name}}</h2>
              <span class="content-item-type">{{item.type}}</span>
            </div>
            <div class="content-item-desc">
              <p class="content-item-feature">{{type !== 'rent' ? `${item.version} | ` : ''}}{{item.powerType}} | {{item.gearboxType}}挡 | {{item.exhaustVolume}}</p>
              <p class="content-item-msrp" v-if="type !== 'rent'">厂商指导价 {{item.guidePrice}} 万元</p>
            </div>
            <div class="content-item-price">
              <div class="content-item-price-sale" v-if="type !== 'rent'">
                <span class="item-price-detail down-payment">首付￥
                  <span>{{item.downPayment}}</span>
                </span>
                <span class="item-price-detail">月供￥
                  <span>{{parseInt(item.monthlyPayment)}}</span>
                </span>
              </div>
              <div class="content-item-price-rent" v-if="type === 'rent'">
                <span class="item-price-detail">
                  ￥<span>{{item.rentPrice}}</span>/日均
                </span>
              </div>
              <img class="content-item-price-label" src="../../assets/showcase-price-label.png">
            </div>
          </div>
          <span class="content-item-hot-label" v-if="item.isHot">热门</span>
        </li>
      </ul>
      <div v-else class="showcase-empty">
        <img src="../../assets/showcase-empty.png">
        <p>当前无搜索结果</p>
        </div>
      <div class="showcase-footer">
        <img src="../../assets/showcase-footer.png">
        <div class="showcase-footer-text">
          <p>成为专车司机后可查看更多优惠车型和详情<br>最低{{type !== 'rent' ? '月供' : '日均租金'}}低至<span> {{minPrice}} </span>元</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
@import "../../styles/variable.styl";
.showcase {
  display: flex;
  flex-flow: column nowrap;

  .showcase-body {
    flex: 1 0 auto;
    position: relative;
    min-height: 800px;
    padding-bottom: 180px;
    box-sizing: border-box;
    background-color: #fff;

    .showcase-ctrl {
      flex-shrink: 0;
      position: sticky;
      z-index: 9;
      top: 0;
      height: 80px;
      color: $ucar_font_color;
      font-size: $ucar_font_h6;
      line-height: 80px;

      .showcase-ctrl-tab {
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid $ucar_light_border; /*no*/

        .showcase-ctrl-tab-item {
          flex: 1 1 33.3%;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          color: $ucar_font_color;

          &::after {
            margin-left: 10px;
            content: "";
            display: block;
            box-sizing: border-box;
            width: 14px;
            height: 14px;
            border-left: 2px solid currentColor;
            border-top: 2px solid currentColor;
            transform: translate3d(0, -30%, 0) rotate(-135deg);
          }

          &.expand::after {
            transform: translate3d(0, 20%, 0) rotate(45deg);
          }

          &.sort {
            flex: 1 0 33.3%;
          }

          &.sort::after {
            height: 24px;
            width: 24px;
            border: none;
            background-image: url('../../assets/sort.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% auto;
            transform: none;
          }

          &.active {
            color: $ucar_price_color;

            &.sort::after {
              background-image: url('../../assets/sort-active.png');
              transform: none;
            }
          }
        }
      }

      .showcase-ctrl-panel {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background-color: #fff;

        ul {
          li {
            position: relative;
            height: 80px;
            padding: 0 30px;

            &.active {
              color: $ucar_main_color;

              &::after {
                content: "";
                position: absolute;
                top: 50%;
                right: 40px;
                transform: translate3d(0, -50%, 0) rotate(45deg);
                box-sizing: border-box;
                width: 10px;
                height: 20px;
                border-right: 3px solid $ucar_main_color;
                border-bottom: 3px solid $ucar_main_color;
              }
            }
          }
        }
      }
    }

    .showcase-mask {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 8;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .showcase-empty {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column nowrap;
      color: $ucar_font_color;

      img {
        width: 70px;
        height: 80px;
      }

      p {
        margin-top: 30px;
        white-space: nowrap;
        font-size: $ucar_font_h6;
      }
    }

    .showcase-footer {
      flex-shrink: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 30px;

      img {
        width: 100%;
      }

      .showcase-footer-text {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 60px;
        font-size: $ucar_font_h6;
        display: flex;
        align-items: center;
        line-height: 1.5;

        span {
          color: $ucar_price_color;
          font-size: $ucar_font_h4;
        }
      }
    }

    ul {
      li {
        position: relative;
        padding: 40px 0 40px 20px;
        line-height: 1;
        display: flex;
        align-items: center;
        line-height: 1;
        background-color: #fff;
        border-bottom: 1px solid $ucar_light_border; /*no*/

        img {
          width: 160px;
          margin-right: 20px;
        }

        .content-item-header {
          display: flex;
          align-items: center;
          margin-bottom: 20px;

          h2 {
            font-size: $ucar_font_normal;
            color: $ucar_font_color;
          }

          .content-item-type {
            margin-left: 20px;
            display: block;
            font-size: $ucar_font_label;
            height: 28px;
            padding: 0 6px;
            line-height: 30px;
            text-align: center;
            color: $ucar_price_color;
            border: 1px solid currentColor; /*no*/
          }
        }

        .content-item-desc {
          font-size: $ucar_font_min;

          p {
            color: $ucar_alert_color;
          }

          .content-item-feature {
            margin-bottom: 20px;
          }

          .content-item-msrp {
            margin-bottom: 20px;
          }
        }

        .content-item-price {
          display: flex;
          align-items: center;

          span.down-payment {
            margin-right: 10px;
          }

          .item-price-detail {
            color: $ucar_font_color;
            font-size: $ucar_font_min;
            margin-right: 10px;

            span {
              color: $ucar_price_color;
              font-size: $ucar_font_h4;
            }
          }

          .content-item-price-label {
            margin-top: 4px;
            height: 24px;
            width: auto;
          }
        }
      }

      .content-item-hot-label {
        position: absolute;
        right: 0;
        top: 0;
        width: 70px;
        height: 36px;
        line-height: 38px;
        font-size: $ucar_font_label;
        color: #fff;
        background-color: $ucar_label_color;
        text-align: center;
        font-weight: bold;
      }
    }
  }
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      type: 'rent',
      title: '...',
      minPrice: '',
      list: [],
      showSortFilter: false,
      showTypeFilter: false,
      showGroupFilter: false,
      showRentFilter: false,
      showMonthlyPaymentFilter: false,
      groupOptions: [
        {
          val: 0,
          text: '新车'
        },
        {
          val: 1,
          text: '准新车'
        }
      ],
      currentGroup: {
        val: 0,
        text: '新车'
      },
      currentSort: {
        val: 0,
        text: '综合排序'
      },
      typeOptions: ['不限', '公务轿车', '商务7座', '豪华轿车'],
      currentType: '不限',
      monthlyPaymentOptions: ['不限', '0-3000', '3000-5000', '5000-8000', '8000-10000', '10000以上'],
      currentMonthlyPayment: '不限',
      rentOptions: ['不限', '0-150', '150-300', '300-500', '500以上'],
      currentRent: '不限'
    }
  },
  computed: {
    ...mapGetters([
      'vuexCurrentCity',
      'vuexRentData',
      'vuexSaleData'
    ]),
    currentPaymentText () {
      let text = this.currentRent
      let result = text === '不限' ? '日租金' : text
      if (this.type !== 'rent') {
        text = this.currentMonthlyPayment
        result = text === '不限' ? '月供' : text
      }
      if (result.length > 6) result = `${result.substr(0, 6)}…`
      return result
    },
    sortOptions () {
      return [
        {
          val: 0,
          text: '综合排序'
        },
        {
          val: 1,
          text: `${this.type === 'rent' ? '租金' : '月供'}由低到高`
        },
        {
          val: 2,
          text: `${this.type === 'rent' ? '租金' : '月供'}由高到低`
        }
      ]
    },
    showMask () {
      return (
        this.showGroupFilter ||
        this.showSortFilter ||
        this.showTypeFilter ||
        this.showRentFilter ||
        this.showMonthlyPaymentFilter
      )
    },
    finalList () {
      let result = this.list.filter(item => {
        if (this.currentType === '不限') return true
        return item.type === this.currentType
      })
      if (this.type === 'rent') {
        result = result.filter(item => {
          if (this.currentRent === '不限') return true
          const range = this.currentRent.match(/\d+/g)
          const min = parseInt(range[0])
          const max = parseInt(range[1])
          if (range.length === 1) {
            return parseInt(item.rentPrice) >= min
          } else {
            return parseInt(item.rentPrice) >= min &&
            parseInt(item.rentPrice) <= max
          }
        })
      } else {
        result = result.filter(item => this.currentGroup.val === 0 && item.isNew)
          .filter(item => {
            if (this.currentMonthlyPayment === '不限') return true
            const range = this.currentMonthlyPayment.match(/\d+/g)
            const min = parseInt(range[0])
            const max = parseInt(range[1])
            if (range.length === 1) {
              return parseInt(item.monthlyPayment) >= min
            } else {
              return parseInt(item.monthlyPayment) >= min &&
            parseInt(item.monthlyPayment) <= max
            }
          })
      }
      return result.sort((pre, next) => {
        if (this.currentSort.val === 0) {
          return pre.isHot ? -1 : 1
        } else {
          const preVal = parseInt(this.type === 'rent' ? pre.rentPrice : pre.monthlyPayment)
          const nextVal = parseInt(this.type === 'rent' ? next.rentPrice : next.monthlyPayment)
          return this.currentSort.val === 1
            ? preVal - nextVal
            : nextVal - preVal
        }
      })
    }
  },
  methods: {
    toggleFilter (tab) {
      const arr = ['Sort', 'Type', 'Group', 'Rent', 'MonthlyPayment']
      const index = arr.indexOf(tab)
      if (index !== -1) arr.splice(index, 1)
      arr.forEach(item => {
        this[`show${item}Filter`] = false
      })
      this[`show${tab}Filter`] = !this[`show${tab}Filter`]
    },
    changeFilter (tab, val) {
      this[`show${tab}Filter`] = false
      this[`current${tab}`] = val
    }
  },
  created () {
    this.type = this.$route.params.type
    this.title = this.type !== 'rent' ? '可买车型' : '可租车型'
    const cityId = this.vuexCurrentCity.id
    const staticData = this.type === 'rent' ? this.vuexRentData : this.vuexSaleData
    const list = staticData.vehiclePrice.filter(item => {
      return item.cityId === cityId
    })
    this.minPrice = parseInt(this.type !== 'rent' ? staticData.cityInfo[cityId].minMonthlyPayment : staticData.cityInfo[cityId].minRentPrice)
    const result = list.map(item => {
      const modelInfo = staticData.vehicleModel[item.vehicleId]
      let host = APP_ENV === 'prod' ? '//img01.10101111cdn.com/download' : '//downloadtest.10101111.com'
      return {
        imgUrl: `${host}/ucarcdnstore/ucar/recruit/assets/${modelInfo.img}.jpg`,
        ...modelInfo,
        ...item
      }
    })
    this.list = result
  }
}
</script>
